import React from 'react';
import { Spin } from 'antd';
import './styles.less';

const Loadable = ( { loading, children } ) => {
    return (
        <Spin 
            spinning={ ( loading === true ) } 
            className="fixed" 
            children={ children }
        /> 
    );
};

export default Loadable;
